const UserEmailModel = require('common/domain/entity/user-email');
const UserEmailElementTemplate = require('common/ui/template/modal/user-email-element.hbs');
const Backbone = require('backbone');
require('backbone.stickit');
require('backbone.marionette');
require('bootstrap');


const UserEmailElementView = Backbone.Marionette.View.extend({
    model: UserEmailModel,
    tagName: 'div',
    className: 'radio',
    template: UserEmailElementTemplate,

    bindings: {
        'input.mail_address': 'mail_address',
        'input.primary_mail_address': 'primary'
    },

    initialize: function() {
        _.bindAll(this, 'setErrors', 'clearErrors');
        this.listenTo(this.model, 'validated:invalid', this.setErrors);
    },

    serializeData: function() {
        const j = this.model.toJSON();
        j['_cid'] = this.model.cid;
        return j;
    },

    onRender: function() {
        const self = this;
        this.stickit();

        if (this.model.get('protected')) {
            this.$('input.mail_address').attr('readonly', true);
        }

        this.$primaryCheckbox = this.$('input.primary_mail_address');
        this.$primaryCheckbox.on('change', function() {
            self.model.set('primary', self.$primaryCheckbox.is(':checked'));
        });
        this.listenTo(this.model, 'change:primary', function() {
            self.$primaryCheckbox.attr('checked', self.model.get('primary'));
        });

        this.$('[data-toggle="tooltip"]').tooltip();

        this.listenTo(this.model, 'validated:invalid', this.setErrors);
    },

    setErrors: function(model, errors) {
        this.clearErrors();
        const self = this;
        _.each(errors, function(message, field) {
            self.$('div.form-group.' + field).addClass('has-error');
            self.$('div.form-group.' + field + ' .alert-message').html(i18n.t(message));
        });
    },

    clearErrors: function() {
        this.$('div.form-group').removeClass('has-error');
        $.each(this.$('div.form-group .alert-message'), function(index, obj) {
            $(obj).html('');
        });
    }
});

const UserEmailListView = Backbone.Marionette.CollectionView.extend({
    tagName: 'div',
    childView: UserEmailElementView
});

module.exports = UserEmailListView;



// WEBPACK FOOTER //
// ./common/ui/view/modal/user-email-list.js